import './styles/index.css';
import './styles/discrete-booking.css';
import App from './App';
import { createRoot } from '@wordpress/element';

console.log('=== DEBUG: Discrete Booking Initialization ===');
console.log('1. Starting initialization');

document.addEventListener('DOMContentLoaded', function() {
    console.log('2. DOM Content Loaded');
    
    const debugElements = () => {
        const container = document.getElementById('discrete-booking-app');
        console.log('3. Container element:', {
            exists: !!container,
            id: container?.id,
            classes: container?.className,
            attributes: container?.attributes ? Array.from(container.attributes).map(attr => `${attr.name}=${attr.value}`) : [],
            style: container?.style?.cssText,
            computedStyle: container ? window.getComputedStyle(container) : null
        });
    };

    const initializeBookingForm = () => {
        const container = document.getElementById('discrete-booking-app');
        
        if (container) {
            console.log('4. Found container, checking initialization status');
            const isInitialized = container.getAttribute('data-booking-initialized') === 'true';
            console.log('5. Container initialization status:', isInitialized);

            if (!isInitialized) {
                try {
                    console.log('6. Creating React root');
                    const root = createRoot(container);
                    console.log('7. Rendering App component');
                    root.render(<App />);
                    container.setAttribute('data-booking-initialized', 'true');
                    console.log('8. React app successfully initialized');
                } catch (error) {
                    console.error('Error initializing React app:', error);
                }
            }
        } else {
            console.warn('Container not found, retrying in 1s');
            setTimeout(() => {
                console.log('Retrying initialization...');
                initializeBookingForm();
                debugElements();
            }, 1000);
        }
    };

    debugElements();
    initializeBookingForm();
});